"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlCountryFlag", function () {
  return {
    restrict: "E",
    replace: true,
    scope: {
      // cf. enum Pays
      isoCode: "="
    },
    template: "<span tl-tooltip=\"{{'lov.pays.'+(isoCode || 'FRA')|translate}}\" class=\"tl-currency-flag flag24 flag-{{flagCode}}\"></span",
    link: function link($scope, $el, $attrs) {
      $scope.code = $scope.isoCode || 'FRA';
      var toFlagCode = function toFlagCode(pays) {
        if (pays == null) {
          return "fr";
        } else return pays.substring(0, 2).toLowerCase();
      };
      $scope.flagCode = toFlagCode($scope.isoCode);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/tl-country-flag.js
// module id = 3016
// module chunks = 13